export const types = {
    CREATING_ORDER: 'CREATING_ORDER',
    CREATE_ORDER_SUCCESS: 'CREATE_ORDER_SUCCESS',
    CREATE_ORDER_FAIL: 'CREATE_ORDER_FAIL',
    CLEAR_ORDER: 'CLEAR_ORDER',
}